


export enum GroupsDefault {
    GROUP_ADMIN = "Administrator",
    GROUP_BACKOFFICE = "Backoffice",
    GROUP_PORTAL = "Comercio",
    GROUP_TOP = "TapOnPhone"
}
